module.exports = __webpack_public_path__ + "img/桃仁.6805fc84.jpg";